
import { UseFormReturn } from "react-hook-form";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";
import { RegisterFormData } from "../schemas/registerFormSchema";
import { useEffect } from "react";

interface AuthFieldsProps {
  form: UseFormReturn<RegisterFormData>;
  defaultEmail?: string | null;
}

export function AuthFields({ form, defaultEmail }: AuthFieldsProps) {
  const { t } = useTranslation();

  // Set default email if provided
  useEffect(() => {
    if (defaultEmail) {
      form.setValue('email', defaultEmail);
    }
  }, [defaultEmail, form]);

  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="email"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('email')}</FormLabel>
            <FormControl>
              <Input
                {...field}
                type="email"
                placeholder={t('enterEmail')}
                autoComplete="email"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="password"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('password')}</FormLabel>
            <FormControl>
              <Input
                {...field}
                type="password"
                placeholder={t('createPassword')}
                autoComplete="new-password"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="confirmPassword"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('confirmPassword')}</FormLabel>
            <FormControl>
              <Input
                {...field}
                type="password"
                placeholder={t('confirmYourPassword')}
                autoComplete="new-password"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
